import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const reviews = [{
  text: 'Nach zwei Wochen hatte unser Hund keine Beschwerden mehr. So einfach.',
  author: 'Thomas aus Hamburg'
}, {
  text: 'Seit wir das Magen-Darm-Topping regelmäßig geben, geht es unserem Labrador viel viel besser.',
  author: 'Familie Weber & Charlie'
}, {
  text: 'Mein Hund hat sich schnell an das Topping gewöhnt – ich bin super zufrieden und bestelle es auf jeden Fall erneut.',
  author: 'Sandra aus Berlin'
}];
export function Testimonials() {
  return <section className="w-full py-12 px-4 md:px-8 max-w-5xl mx-auto" data-id="element-99">
      <h2 className="text-center font-handwritten text-4xl text-forest-green font-bold mb-10" data-id="element-100">
        Erfahrungen anderer Hundehalter
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-101">
        {reviews.map((review, index) => <motion.div key={index} className="bg-white p-6 rounded-xl shadow-diary border border-warm-brown/10 flex flex-col h-full" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.15
      }} data-id="element-102">
            <div className="flex gap-1 mb-4 text-yellow-400" data-id="element-103">
              {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="currentColor" data-id="element-104" />)}
            </div>
            <p className="text-gray-700 italic flex-grow mb-4" data-id="element-105">
              "{review.text}"
            </p>
            <p className="font-bold text-sm text-forest-green" data-id="element-106">
              – {review.author}
            </p>
          </motion.div>)}
      </div>
    </section>;
}